import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button, Result, Descriptions } from 'antd';
import { CheckCircleFilled, UserOutlined, ShopOutlined, CustomerServiceOutlined } from '@ant-design/icons';
import { useLocale } from '../context/LocaleContext';

const RegisterSuccess: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useLocale();

  const state = (location.state as any) || {};
  const { store_no, username, salesperson_name, store_name } = state;

  // 如果没有 state（直接访问此页），跳到注册页
  if (!store_no) {
    navigate('/register', { replace: true });
    return null;
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f0f4f8' }}>
      <div style={{ width: '100%', maxWidth: 480, margin: '0 16px', padding: '40px 40px 32px', background: '#fff', borderRadius: 12, boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <CheckCircleFilled style={{ fontSize: 56, color: '#52c41a' }} />
          <div style={{ fontSize: 22, fontWeight: 700, color: '#1a1a1a', marginTop: 12 }}>{t('注册成功')}</div>
          <div style={{ fontSize: 14, color: '#888', marginTop: 6 }}>{t('请妥善保存以下信息')}</div>
        </div>

        <div style={{ background: '#f6ffed', border: '1px solid #b7eb8f', borderRadius: 8, padding: '16px 20px', marginBottom: 24 }}>
          <Descriptions column={1} size="small" labelStyle={{ color: '#555', fontWeight: 600, width: 120 }} contentStyle={{ color: '#222', fontWeight: 700 }}>
            {store_name && (
              <Descriptions.Item label={
                <span><ShopOutlined style={{ marginRight: 6, color: '#1a5fb4' }} />{t('店铺名')}</span>
              }>
                {store_name}
              </Descriptions.Item>
            )}
            <Descriptions.Item label={
              <span><ShopOutlined style={{ marginRight: 6, color: '#1a5fb4' }} />{t('门店编号')}</span>
            }>
              <span style={{ color: '#1a5fb4', fontSize: 16 }}>{store_no}</span>
            </Descriptions.Item>
            <Descriptions.Item label={
              <span><UserOutlined style={{ marginRight: 6, color: '#1a5fb4' }} />{t('系统登录账号')}</span>
            }>
              <span style={{ color: '#d46b08', fontSize: 16 }}>{username}</span>
            </Descriptions.Item>
            {salesperson_name && (
              <Descriptions.Item label={
                <span><CustomerServiceOutlined style={{ marginRight: 6, color: '#1a5fb4' }} />{t('服务设计师')}</span>
              }>
                {salesperson_name}
              </Descriptions.Item>
            )}
          </Descriptions>
        </div>

        <div style={{ background: '#fffbe6', border: '1px solid #ffe58f', borderRadius: 8, padding: '10px 16px', marginBottom: 24, fontSize: 13, color: '#874d00' }}>
          {t('登录账号与门店编号相同。账号需由业务员激活后才能登录，请联系您的业务员激活')}
        </div>

        <Button type="primary" block size="large" onClick={() => navigate('/login', { replace: true })}>
          {t('立即登录')}
        </Button>
      </div>
    </div>
  );
};

export default RegisterSuccess;
